export default __webpack_public_path__ + "static/media/risk.6c1388f2.png";